import type { ReactNode } from "react";
import { QueryClientProvider } from "react-query";
import { ThemeProvider } from "@hightouch/htui";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { FeatureFlagProvider } from "src/contexts/feature-flags";
import { UserProvider } from "src/contexts/user-context";
import { CommandBar } from "src/components/commandbar";
import { HeaderHeightProvider } from "src/contexts/header-height-context";
import { GlobalStyles } from "src/components/global-styles";
import { ErrorBoundary } from "src/components/error-boundary";
import { queryClient } from "src/lib/react-query";
import { NavWidthProvider } from "src/contexts/nav-width-context";
import { SpaceProvider } from "src/components/spaces";

export const RootProviders = ({ children }: { children: ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <GoogleOAuthProvider
          clientId={import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID}
        >
          {children}
          <GlobalStyles />
        </GoogleOAuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export const AppProviders = ({ children }: { children: ReactNode }) => {
  return (
    <ErrorBoundary>
      <UserProvider>
        <FeatureFlagProvider>
          <SpaceProvider>
            <HeaderHeightProvider>
              <NavWidthProvider>
                <CommandBar>{children}</CommandBar>
              </NavWidthProvider>
            </HeaderHeightProvider>
          </SpaceProvider>
        </FeatureFlagProvider>
      </UserProvider>
    </ErrorBoundary>
  );
};
